
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Layouts/MasonryLayout.html",
      function () {
        return require("private-next-pages/Layouts/MasonryLayout.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Layouts/MasonryLayout.html"])
      });
    }
  